import React from 'react';
import PropTypes from 'prop-types';
import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
};

const HelpAndSupport = ({ brand }) => (
  <div className="visible-print-block">
    <div>Need Help? Contact Our Support Center!</div>
    <div>{brand.helpPhone}</div>
    <div>{brand.helpHours}</div>
  </div>
);

HelpAndSupport.propTypes = propTypes;
HelpAndSupport.defaultProps = defaultProps;

export default HelpAndSupport;
